import axois from "axios";
import sender from "./sender";

// IDOM project service
export class Iev4sApiService {
  get url() {
    return "/api/iev4s";
  }

  constructor(host) {
    this.http = axois.create({
      baseURL: host,
    });
  }

  get(method, params, headers = {}) {
    const path = `${this.url}/${method}`;
    return sender.restGet(path, params, headers);
  }

  post(method, body, headers = {}) {
    const path = `${this.url}/${method}`;
    return sender.restPost(path, body, headers);
  }

  upload_image(body) {
    return this.post("upload/image", body);
  }
}
